<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/NetworkIDTs"
        >Financial Services</b-breadcrumb-item
      >
      <b-breadcrumb-item active>Leasing IDTs</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card">
      <div class="bg-dark card-header text-white">Leasing IDTs</div>
      <div class="card-body">
        <!-- The collapsable filter options -->
      </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      leasingIDTs: [],
      totalLeasingIDTs: 0,
      filterOptions: {
        page: 1,
        pageSize: 10,
        sl: null,
      },
      isLoading: false
    };
  },
  methods: {
    onFilterSubmit() {
      this.filterOptions.page = 1;
    },
  }
};
</script>
